// extracted by mini-css-extract-plugin
export default {"MetricsColumn":"MetricsColumn_MetricsColumn__NnE72"};